import { TakeAwayProps } from '@/interfaces/models/takeAway';
import TakeAway from '@/models/takeAway';
import axiosHelper from '@/helpers/axiosHelper';

export default axiosHelper.mergeAxiosResponseTransformerWithDefaults(
  (takeAwayProps: TakeAwayProps[]): TakeAway[] => takeAwayProps.map(TakeAway.createFromRequest),
);
